import React from "react";
import { Box } from "@mui/material";
import FormikControl from "../../../../../components/formComponents/FormikControl";
import i18next from "i18next";
import { Form, Formik } from "formik";
import _ from "lodash";
import PropTypes from "prop-types";

const GroupSelectComponent = (props) => {
  const {
    GroupList,
    open,
    setOpen,
    setClicked,
    setSelectedGroup,
    setSelectedGroupId,
  } = props;

  return (
    <Formik
      initialValues={{ Group_name: null }}
      enableReinitialize
      onSubmit={(values) => {
        console.log(values);
      }}
    >
      {({ values, handleSubmit }) => {
        return (
          <Box
            className={"textboxDoubleWraper"}
            data-testid="GroupSelectComponent"
          >
            <Form onSubmit={handleSubmit}>
              <FormikControl
                variant="filled"
                control="autocomplete"
                dropDownEnabled={false}
                options={GroupList}
                hiddenLabel
                size="small"
                isSelect={false}
                disabled={true}
                id="Groupname"
                name="Groupname"
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => {
                  setOpen(false);
                }}
                forcePopupIcon={false}
                noOptionsText={
                  <Box>
                    <Box>{i18next.t("No results found")}</Box>
                  </Box>
                }
                freeSolo={false}
                hasSubText={true}
                subTextField={{ title: "key", subText: ["group_City"] }}
                onChange={(e, value) => {
                  setSelectedGroupId(_.get(value, "dealergroup_Id", 0));
                  setSelectedGroup(value);
                  setClicked(false);
                }}
                value={values.Group_name}
                className="input-grp__box select"
                onBlur={(e) => setClicked(false)}
              />
            </Form>
          </Box>
        );
      }}
    </Formik>
  );
};

export default GroupSelectComponent;
GroupSelectComponent.propTypes = {
  GroupList: PropTypes.any,
  open: PropTypes.any,
  setOpen: PropTypes.any,
  setClicked: PropTypes.any,
  setSelectedGroup: PropTypes.any,
  setSelectedGroupId: PropTypes.any,
};
